module.exports = __webpack_public_path__ + "img/colaborador(8).de863d5c.png";